import { render, staticRenderFns } from "./AcquisitionBoosterDashboard.vue?vue&type=template&id=1908bf08&scoped=true&"
import script from "./AcquisitionBoosterDashboard.vue?vue&type=script&lang=js&"
export * from "./AcquisitionBoosterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AcquisitionBoosterDashboard.vue?vue&type=style&index=0&id=1908bf08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908bf08",
  null
  
)

export default component.exports